import React from "react";

const solutions = [
  {
    title: "Техподдержка",
    icon: "🛠️",
    tag: "24/7",
    text: "Круглосуточное обслуживание Ваших информационных систем .",
  },
  {
    title: "Инфобезопасность",
    icon: "🛡️",
    tag: "КИИ",
    text: "Аудит, защита информационной инфраструктуры и соответствие нормам безопасности.",
  },
  {
    title: "Автоматизация",
    icon: "⚙️",
    tag: "ERP",
    text: "Внедрение систем управления и оптимизация бизнес-процессов любой сложности.",
  },
  {
    title: "Разработка",
    icon: "💻",
    tag: "Code",
    text: "Индивидуальные программные решения на современном технологическом стеке.",
  },
];

export default function Solutions() {
  return (
    <section id="solutions" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <h2 className="text-4xl font-black text-slate-900 uppercase">
              Решения
            </h2>
            <p className="text-slate-500 mt-2">
              Комплексный подход к ИТ-задачам
            </p>
          </div>
          <div className="h-px flex-1 bg-slate-200 mx-8 hidden md:block"></div>
        </div>

        <div className="grid md:grid-cols-4 gap-6">
          {solutions.map((s, i) => (
            <div
              key={i}
              className="bg-white p-8 rounded-3xl border border-slate-100 hover:border-blue-500 transition-all group cursor-default"
            >
              <div className="flex justify-between items-start mb-6">
                <div className="text-4xl">{s.icon}</div>
                <span className="text-[10px] font-black bg-slate-100 px-2 py-1 rounded uppercase">
                  {s.tag}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-3 group-hover:text-blue-600 transition-colors">
                {s.title}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
